import Header from './components/Header';
import Hero from './components/Hero';
import Topics from './components/Topics';
import About from './components/About';
import Ranking from './components/Ranking';
import Comments from './components/Comments';
import FAQ from './components/FAQ';
import Features from './components/Features';
import Carousel from './components/Carousel';
import Updates from './components/Updates';
import Cards from './components/Cards';
import Contact from './components/Contact';
import Index from './components/Index';
import Media from './components/Media';
import App from './components/App';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Topics />
        <About />
        <Ranking />
        <Comments />
        <FAQ />
        <Features />
        <Carousel />
        <Updates />
        <Cards />
        <Contact />
        <Index />
        <Media />
        <App />
      </main>
      <Footer />
    </div>
  );
}